export const webstoreConstants = {
  GET_SINGLE_REQUEST: "WEBSTORE_GET_SINGLE_REQUEST",
  GET_SINGLE_SUCCESS: "WEBSTORE_GET_SINGLE_SUCCESS",
  GET_SINGLE_FAILURE: "WEBSTORE_GET_SINGLE_FAILURE",

  GET_ALL_REQUEST: "WEBSTORE_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "WEBSTORE_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "WEBSTORE_GET_ALL_FAILURE",

  ADD_REQUEST: "WEBSTORE_ADD_REQUEST",
  ADD_SUCCESS: "WEBSTORE_ADD_SUCCESS",
  ADD_FAILURE: "WEBSTORE_ADD_FAILURE",

  UPDATE_REQUEST: "WEBSTORE_UPDATE_REQUEST",
  UPDATE_SUCCESS: "WEBSTORE_UPDATE_SUCCESS",
  UPDATE_FAILURE: "WEBSTORE_UPDATE_FAILURE",

  DELETE_REQUEST: "WEBSTORE_DELETE_REQUEST",
  DELETE_SUCCESS: "WEBSTORE_DELETE_SUCCESS",
  DELETE_FAILURE: "WEBSTORE_DELETE_FAILURE",

  CLEAR: "WEBSTORE_CLEAR",
};
